import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import axios from "axios";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_data");
    setUser(null);
    window.location.href = "/";
  }, []);

  // --- GLOBAL ERROR INTERCEPTOR ---
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // 1. Check for 401 Unauthorized
        if (error.response && error.response.status === 401) {
          // 2. CRITICAL FIX: Ignore 401s from the Login endpoint itself.
          // We let the Login component handle "Wrong Password" errors.
          const isLoginRequest =
            error.config.url && error.config.url.includes("/login");

          if (!isLoginRequest) {
            console.warn("Session expired. Logging out.");
            logout();
          }
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [logout]);

  // --- INITIALIZE STATE ---
  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user_data");

    if (token) {
      try {
        setUser(storedUser ? JSON.parse(storedUser) : { email: "User" });
      } catch (e) {
        logout();
      }
    }
    setLoading(false);
  }, [logout]);

  const login = (token, userData) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user_data", JSON.stringify(userData));
    setUser(userData);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
